import Axios from "axios";
import {
  SET_WORK_ORDER_ROUTES_LIST,
  UNSET_WORK_ORDER_ROUTES_LIST,
  SET_WORK_ORDER_STATUS_LIST,
  UNSET_WORK_ORDER_STATUS_LIST,
} from "@/store/mutation-types";
import { getSalesWorkOrderList, saveUpdateSalesWorkOrder, getSalesWorkOrderById, getCustomerByWorkOrderId, getSalesWorkOrderStatusList } from "@/store/api";

// initial state
const state = {
  getSalesWorkOrderList: [],
  getSalesWorkOrderStatusList: [],
  editingSalesWorkOrder: null,
};

const getters = {
  getSalesWorkOrderList(state) {
    return state.getSalesWorkOrderList;
  },
  getSalesWorkOrderStatusList(state) {
    return state.getSalesWorkOrderStatusList;
  },
  getEditingSalesWorkOrder: (state) => state.editingSalesWorkOrder,
};

const mutations = {
  [SET_WORK_ORDER_ROUTES_LIST](state, data) {
    state.getSalesWorkOrderList = data;
  },
  [UNSET_WORK_ORDER_ROUTES_LIST](state) {
    state.getSalesWorkOrderList = [];
  },
  [SET_WORK_ORDER_STATUS_LIST](state, data) {
    state.getSalesWorkOrderStatusList = data;
  },
  [UNSET_WORK_ORDER_STATUS_LIST](state) {
    state.getSalesWorkOrderStatusList = [];
  },
  setEditingSalesWorkOrder(state, workorder) {
    state.editingSalesWorkOrder = workorder;
  },
};

const actions = {
  saveUpdateSalesWorkOrder({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSalesWorkOrder, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSalesWorkOrderList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSalesWorkOrderList, data)
        .then(function (response) {
          commit("SET_WORK_ORDER_ROUTES_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_WORK_ORDER_ROUTES_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  getSalesWorkOrderStatusList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getSalesWorkOrderStatusList, data)
        .then(function (response) {
          commit("SET_WORK_ORDER_STATUS_LIST", response.data.data);
          resolve(response.data.data);
        })
        .catch(function (error) {
          commit("UNSET_WORK_ORDER_STATUS_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  getSalesWorkOrderById({ commit }, data) {
    const getSalesWorkOrderByIdApi = `${getSalesWorkOrderById}/${data}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getSalesWorkOrderByIdApi)
        .then((response) => {
          resolve(response.data);
          commit("UNSET_LOADING");
        })
        .catch((error) => {
          reject(error);
          commit("UNSET_LOADING");
        });
    });
  },
  getCustomerByWorkOrderId({ commit }, data) {
    const getCustomerByWorkOrderIdApi = `${getCustomerByWorkOrderId}/${data}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getCustomerByWorkOrderIdApi)
        .then((response) => {
          resolve(response.data);
          commit("UNSET_LOADING");
        })
        .catch((error) => {
          reject(error);
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
